import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
// import { changeCouponStatus } from "services/discountManagement";
import { toastMessage } from "utils/toastMessage";
import { changeCategoryStatus } from "services/category";
import { subCategoryStatusApi } from "services/subCategory";
import { changeSelectedBannerStatus } from "services/banner-management";

const ChangeBannerStatus = ({
  selectedBannerDetail,
  onClose,
  bannerMgmtApiCall,
  statusModal,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  // console.log("it is selected Token status:--------", selectedBannerDetail);

  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        id: selectedBannerDetail?._id || "",
        status:
          selectedBannerDetail.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };

      const {
        data: { code, status, message },
      } = await changeSelectedBannerStatus(reqData);
      if (status || code === 200) {
        bannerMgmtApiCall();
        onClose();
        toastMessage(message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={statusModal}
        handleClose={onClose}
        content="Are you sure you want to change the status of this Banner?"
        title="Change Banner Status"
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default ChangeBannerStatus;
